/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import { Alert, Box, Snackbar } from '@mui/material';
import ModalLoadingSpinner from '../../common/layout/ModalLoadingSpinner';

export interface ManualDowntimeFeedbackContainerProps {
  isRequestingManualDowntimePeriods: boolean;
  isAddingManualDowntimePeriod: boolean;
  isDeletingManualDowntimePeriod: boolean;
  manualDowntimeDeleteErroredSnackbarVisible: boolean;
  manualDowntimeAddErroredSnackbarVisible: boolean;
  onCloseManualDowntimeDeleteErroredSnackbar: () => void;
  onCloseManualDowntimeAddErroredSnackbar: () => void;
}
const ManualDowntimeFeedbackContainer = ({
  isAddingManualDowntimePeriod,
  isDeletingManualDowntimePeriod,
  isRequestingManualDowntimePeriods,
  manualDowntimeDeleteErroredSnackbarVisible,
  manualDowntimeAddErroredSnackbarVisible,
  onCloseManualDowntimeDeleteErroredSnackbar,
  onCloseManualDowntimeAddErroredSnackbar,
}: ManualDowntimeFeedbackContainerProps) => {
  return (
    <>
      <Box>
        {isRequestingManualDowntimePeriods || isAddingManualDowntimePeriod || isDeletingManualDowntimePeriod ? (
          <ModalLoadingSpinner></ModalLoadingSpinner>
        ) : (
          <></>
        )}
      </Box>
      <Box>
        <Snackbar
          open={manualDowntimeDeleteErroredSnackbarVisible}
          autoHideDuration={5000}
          onClose={() => {
            onCloseManualDowntimeDeleteErroredSnackbar();
          }}
        >
          <Alert
            onClose={() => {
              onCloseManualDowntimeDeleteErroredSnackbar();
            }}
            severity="error"
            sx={{ width: '100%' }}
          >
            Could not delete manual downtime period
          </Alert>
        </Snackbar>
        <Snackbar
          open={manualDowntimeAddErroredSnackbarVisible}
          autoHideDuration={5000}
          onClose={() => {
            onCloseManualDowntimeAddErroredSnackbar();
          }}
        >
          <Alert
            onClose={() => {
              onCloseManualDowntimeAddErroredSnackbar();
            }}
            severity="error"
            sx={{ width: '100%' }}
          >
            Could not add manual downtime period
          </Alert>
        </Snackbar>
      </Box>
    </>
  );
};

export default ManualDowntimeFeedbackContainer;
